import { render } from "./UsefulTrainings.vue?vue&type=template&id=cd70992c&ts=true"
import script from "./UsefulTrainings.vue?vue&type=script&lang=ts"
export * from "./UsefulTrainings.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__